import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import CONFIG from 'common/config/header.json';
import './index.styl';

const clzpre = 'ssfe-header';

class Header extends Component {
    getMenuByConfig = menu => {
        const path = this.props.location.pathname.split('/').filter(v => !!v);
        const curKey = path[0] || 'dashboard';
        return menu.map(m => (
            <span key={m.key} className={curKey === m.key ? 'active' : ''}>
                <Link to={m.path}>{m.name}</Link>
            </span>
        ));
    };

    render() {
        return (
            <header className={clzpre}>
                <p>{this.getMenuByConfig(CONFIG.left_menu)}</p>
                <h1>{CONFIG.title}</h1>
                <p>{this.getMenuByConfig(CONFIG.right_menu)}</p>
            </header>
        );
    }
}

export default withRouter(Header);
